// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Types
import { ChartSetFour } from "../Libs/Types/ChartTypes";
// Utils
import {
  chartColors,
  CHART_AXIS_FALLBACK,
  humanize,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function PieChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetFour["PieChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    fill: {
      colors: chartColors,
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "8px",
      },
    },
    labels:
      chartData !== undefined ? chartData["data"][0]["labels"] : undefined,
    legend: {
      show: false,
      position: "right",
      fontSize: "10px",
      formatter: function (legendName) {
        return legendName.substring(0, 30);
      },
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
  };
  const series: any =
    chartData !== undefined ? chartData["data"][0]["data"] : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined && option.labels !== undefined ? (
        <ApexChart
          type="pie"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
